import CanvasManager from "slotworks/graphics/canvas/canvas-manager";
import { PrecannedResultList } from "slotworks/server/precanned/precanned-result-list";
import DeviceInfo from "slotworks/utils/device-info";

export default class PrecannedResultSelectComponent {

    public static create(precanController: PrecannedResultList) {
        const resultForcer = new PrecannedResultSelectComponent();
        precanController.getList().then((list: string[]) => {
            resultForcer.init(list, precanController);
        });

        window.onkeyup = (e: any) => {
            const key = e.keyCode ? e.keyCode : e.which;

            if (key === 70 && e.shiftKey) {
                resultForcer.show();
            }
        };

        if (!DeviceInfo.isDesktop) {
            const mc = CanvasManager.hammer;
            mc.add(new Hammer.Pinch());

            // subscribe to events
            mc.on("pinchout", (e: any) => {
                resultForcer.show();
            });
        }
    }

    private domElement: HTMLElement;

    public init(precans: string[], precanController: PrecannedResultList) {
        this.domElement = document.createElement("div");

        this.domElement.style.width = "80vw";
        this.domElement.style.height = "80vh";
        this.domElement.style.position = "fixed";
        this.domElement.style.top = "10vh";
        this.domElement.style.left = "10vw";
        this.domElement.style.zIndex = "1000";
        this.domElement.style.padding = "2vw";
        this.domElement.style.overflow = "auto";
        this.domElement.style.borderRadius = "10px";

        this.domElement.style.backgroundColor = "rgba(30, 30, 30, 0.85)";

        // Add buttons
        for (const precan of precans) {
            const btn = document.createElement("button");

            btn.style.fontSize = "3vw";
            btn.style.margin = "1vmax 1vw";
            btn.style.borderRadius = "10px";
            btn.style.width = "38vw";
            btn.style.height = "10vmax";
            btn.style.backgroundColor = "#ffffff";
            btn.innerText = precan;

            btn.onclick = () => {
                precanController.force(precan).execute();
                this.hide();
            };

            this.domElement.appendChild(btn);
        }

        document.body.appendChild(this.domElement);

        this.hide();
    }

    public show() {
        this.domElement.style.visibility = "visible";
    }

    public hide() {
        this.domElement.style.visibility = "hidden";
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/precanned/precanned-result-select-component.ts